import { CustomerOrganizationsResult } from "../../types/queries";
import { TabValue } from "../../types/types";
import CustomerOrganizationFilter from "./CustomerOrganizationFilter";
import EezyCompanyFilter from "./EezyCompanyFilter";

type Props = {
  selectedTab: TabValue;
  filters: CustomerOrganizationsResult[];
  representativeOrganization: CustomerOrganizationsResult;
};

const FiltersList = ({
  selectedTab,
  filters,
  representativeOrganization,
}: Props) => {
  switch (selectedTab) {
    case "orderTemplates":
    case "contracts":
      return (
        <EezyCompanyFilter
          representativeOrganization={representativeOrganization}
          selectedTab={selectedTab}
        />
      );
    default:
      return (
        <CustomerOrganizationFilter
          filters={filters}
          selectedTab={selectedTab}
        />
      );
  }
};

export default FiltersList;
